import { Card, Col, Row, Button } from "antd";
import { Link } from "react-router-dom";
import "./MainPageView.css";
import HeroCarousel from "../hero-carousel/hero-carousel";
import ProductCards from "../product-cards/product-cards";
import ClientsSection from "../clients-section/clients-section";
import MapSection from "../map-section/map-section";
import ReviewsSection from "../reviews-section/reviews-section";
import AppTitle from "../app-title/app-title";
import Feedback from "../feedback/feedback";
import MainPageAdvantagesSection from "./MainPageAdvantagesSection";
import MainPageFaqSection from "./MainPageFaqSection";
import { PRODUCT_GROUPS } from "../../constants/product-groups";

function MainPageView() {
  return (
    <div className="main">
      <HeroCarousel />
      <AppTitle text={"Авто в наличии"} />
      <Row className="content">
        <ProductCards countCards={4} groupsID={[PRODUCT_GROUPS.CARS]} />
        <ProductCards countCards={4} groupsID={[PRODUCT_GROUPS.COMMERCIAL]} />
        <ProductCards
          countCards={8}
          groupsID={[PRODUCT_GROUPS.DAF, PRODUCT_GROUPS.SCANIA]}
        />
        <ProductCards countCards={4} groupsID={[PRODUCT_GROUPS.TRAILERS]} />
      </Row>
      <Row className="content">
        <Col className="button-all-goods">
          <Button>
            <Link to="/catalogue">Посмотреть&nbsp;ещё</Link>
          </Button>
        </Col>
      </Row>

      <Row>
        <Feedback
          text={
            <>
              Напишите свои контакты
              <br /> и мы
              <span style={{ color: "#F67828" }}> вам перезвоним </span>
              <br></br>
              Подберём лучший авто для вас
            </>
          }
        />
      </Row>

      <MapSection />

      <MainPageAdvantagesSection />

      <Row>
        <ClientsSection type="main" />
      </Row>

      <AppTitle text={"Популярные модели"} />
      <Row className="content">
        <ProductCards
          countCards={4}
          groupsID={[PRODUCT_GROUPS.DAF, PRODUCT_GROUPS.SCANIA]}
        />
      </Row>
      <Row className="content">
        <Col className="button-all-goods">
          <Button>
            <Link to="/catalogue">Посмотреть&nbsp;ещё</Link>
          </Button>
        </Col>
      </Row>

      <ReviewsSection titleClassName="title__h2--after-button-gap" />

      <MainPageFaqSection />
    </div>
  );
}

export default MainPageView;
